module.exports = __webpack_public_path__ + "img/slogan_TW-7ee9e07b.png";